(ns machtfit.stepchall.tooltip
  (:require [goog.string :as gstring]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [tr trn t tn format-date]]
            [medley.core :refer [map-vals]]
            [re-frame.core :as rf]))

(defn- tooltip-element [{:keys [title line-one line-two own-team?]
                         {:keys [x y]} :coordinates}]
  [:div.sc_tooltip {:style {:left (str x "%")
                            :top (str y "%")}
                    :class [(when own-team? "sc_tooltip-own-team")
                            (cond
                              (> 20 x) "sc_tooltip-left"
                              (< 80 x) "sc_tooltip-right"
                              (> 20 y) "sc_tooltip-bottom"
                              :else "sc_tooltip-top")]}
   (when title [:p.sc_tooltip_team title])
   (when line-one [:p line-one])
   (when line-two [:p [:b line-two]])])

(defn- relative-position-in-route-view [{:keys [x y]}]
  (let [route-view-width @(rf/subscribe [:get [:stepchall :route :background-image :width]])
        route-view-height @(rf/subscribe [:get [:stepchall :route :background-image :height]])
        viewport-width 1000
        viewport-height (* viewport-width (/ route-view-height route-view-width))
        x (* 100 (/ x viewport-width))
        y (* 100 (/ y viewport-height))]
    {:x x
     :y y}))

(rf/reg-sub ::route-teams-by-id
  :<- [::subs/teams]

  (fn [teams _]
    (->> teams
         (group-by :id)
         (map-vals first))))

(rf/reg-sub ::route-team-by-id
  :<- [::route-teams-by-id]

  (fn [teams [_ id]]
    (teams id)))

(defn- team-tooltip []
  (let [id @(rf/subscribe [:get [:ui :stepchall :tooltip :id]])
        team @(rf/subscribe [::route-team-by-id id])
        steps (-> team :step-counts :total)
        {:keys [singular plural]} @(rf/subscribe [:get [:stepchall :main-unit]])]
    [tooltip-element {:title (t (:name team))
                      :line-one (gstring/format (trn "%d Mitglied" "%d Mitglieder" (:member-count team)) (:member-count team))
                      :line-two (str steps " " (tn singular plural steps))
                      :coordinates (relative-position-in-route-view team)}]))

(rf/reg-sub ::route-stages-by-num-steps
  :<- [::subs/stages]

  (fn [stages _]
    (->> stages
         (group-by :num-steps)
         (map-vals first))))

(rf/reg-sub ::route-stage-by-num-steps
  :<- [::route-stages-by-num-steps]

  (fn [stages [_ num-steps]]
    (stages num-steps)))

(defn- stage-tooltip []
  (let [tooltip-num-steps @(rf/subscribe [:get [:ui :stepchall :tooltip :num-steps]])
        stage @(rf/subscribe [::route-stage-by-num-steps tooltip-num-steps])
        {stage-name :name
         num-steps :num-steps} stage
        {:keys [singular plural]} @(rf/subscribe [:get [:stepchall :main-unit]])]
    [tooltip-element {:title (t stage-name)
                      :line-one (case num-steps
                                  0 (->> @(rf/subscribe [:get [:stepchall :challenge-start-date]])
                                         format-date
                                         (str (tr "am ")))
                                  (= @(rf/subscribe [:get [:stepchall :goal]])) (->> @(rf/subscribe [:get [:stepchall :challenge-end-date]])
                                                                                     format-date
                                                                                     (str (tr "bis zum ")))
                                  nil)

                      :line-two (when (pos? num-steps)
                                  (gstring/format (str "%d " (tn singular plural num-steps)) num-steps))
                      :coordinates (relative-position-in-route-view stage)}]))

(defn tooltip []
  (case @(rf/subscribe [:get [:ui :stepchall :tooltip :type]])
    :team-marker-tooltip [team-tooltip]
    :stage-marker-tooltip [stage-tooltip]
    nil))

(defn own-team-tooltip []
  (when @(rf/subscribe [::subs/is-team-member?])
    (let [id @(rf/subscribe [:get [:stepchall :team :id]])
          team @(rf/subscribe [::route-team-by-id id])]
      [tooltip {:line-one (t {:de "Dein Team"
                              :en "Your team"})
                :own-team? true
                :coordinates (relative-position-in-route-view team)}])))
